var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 19.5754L19.4468 7.8L26.5434 19.5754L19.4468 23.7702L19.4468 23.7702L12.35 19.5754ZM19.4468 30.9217L12.35 20.9212L19.4468 25.1139L26.5478 20.9212L19.4468 30.9217Z",
    fill: "#1C1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/Ethereum-icon.a4c9d51e433b8351888d1adf5f17ecd9.svg";
export { ForwardRef as ReactComponent };